function linkBoxes () {
  var boxes = document.querySelectorAll('.js-block')

  boxes.forEach(function (box) {
    var link = box.querySelector('a')
    if (link) {
      var url = link.getAttribute('href')
      box.addEventListener('click', function () {
        document.location.href = url
        link.preventDefault()
      })
      box.classList.add('linkify')
      link.addEventListener('focus', function () {
        box.classList.add('isfocused')
      })
      link.addEventListener('blur', function () {
        box.classList.remove('isfocused')
      })
    }
  })
}

function linkCtas () {
  const cards = document.querySelectorAll('.js-cta')
  Array.prototype.forEach.call(cards, (card) => {
    let link = card.querySelector('a')
    let button = card.querySelector('.js-faux-link')
    let newWindow
    let url
    if (link) {
      newWindow = link.getAttribute('target') === '__blank'
      url = link.getAttribute('href')
      button.style.cursor = 'pointer'
    }
    if (link && newWindow) {
      button.addEventListener('click', function (e) {
        window.open(url, '__blank').focus()
        e.preventDefault()
      })
    } else if (link) {
      button.addEventListener('click', function (e) {
        document.location.href = url
        e.preventDefault()
      })
    }
  })
}

document.addEventListener('DOMContentLoaded', function () {
  if ('querySelector' in document) {
    linkBoxes()
    linkCtas()
  }
})
